import React from 'react';
import Card from './Card';


class Listings extends React.Component{

  constructor(props) {
    super(props);
  }

  render() {

    let cards = this.props.listings.map(item => {
      return (
        <Card key={ item.key } listing={ item } />
      );
    });

    return (

      <div className="jobs-listings-wrapper">

        <div className="jobs-listings-headline column-heading">
          <h3>Open Positions</h3>
          <p className="jobs-listings-directions">Apply below, or direct questions <a href="mailto:shazna.nessa@wsj.com">here</a>.</p>
        </div>

        { cards }

      </div>

    );

  }

};

export default Listings;



// WEBPACK FOOTER //
// ./src/components/Jobs/Listings/index.js